module.exports = __webpack_public_path__ + "media/images/logo-alt-f90c3f3297e60fd63bd564b88a7e640f.png";